"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : NAV : BREADCRUMB : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  breadcrumbnav: {
    // padding: replacePXinStringWithEM('0px 30px'),
    fontSize: (0, _index.pxToEm)(20),
    fontWeight: 300,
    // margin-top: 5px;
    overflow: 'hidden',
    width: 'fit-content',
    '& .name-crumbnav': {
      display: 'flex',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      padding: (0, _index.replacePXinStringWithEM)('0px 15px'),
      color: 'rgb(20, 148, 244)',
      fontSize: (0, _index.pxToEm)(12),
      fontWeight: '500',
      background: 'rgba(20, 148, 244, 0.09)',
      borderRadius: (0, _index.pxToEm)(22),
      '& .horizontal-breadcrumb-wrap': {
        display: 'none',
        padding: (0, _index.replacePXinStringWithEM)('10px 5px 10px 0px'),
        position: 'relative',
        transition: 'transform ease-in-out .3s',
        borderBottom: "".concat((0, _index.pxToEm)(1), " solid transparent"),
        '& .page-icon': {
          padding: (0, _index.replacePXinStringWithEM)('0px 5px')
        },
        '& .sep': {
          padding: (0, _index.replacePXinStringWithEM)('0px 10px')
        }
      },
      '& .normal-breadcrumb-wrap': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flex: '0 auto',
        flexShrink: '1000',
        display: 'inline-block',
        // padding: replacePXinStringWithEM('12px 5px 12px 0px'),
        borderBottom: "".concat((0, _index.pxToEm)(1), " solid transparent"),
        position: 'relative',
        transition: 'transform .15s ease-in-out 0s',
        //First Breadcrumb
        '&:first-child': {
          flex: '0 0 auto',
          flexShrink: function flexShrink(props) {
            return props.items.length <= 2 ? '200' : '0.5';
          },
          '&:after': {
            left: 0
          }
        },
        '& .name-breadcrumbitem': {
          display: 'inline-flex',
          padding: (0, _index.replacePXinStringWithEM)('12px 5px 12px 0px'),
          flex: '0 1 auto',
          '& .page-icon': {
            padding: (0, _index.replacePXinStringWithEM)('0px 7px 0px 5px')
          }
        },
        '& .sep': {
          padding: (0, _index.replacePXinStringWithEM)('0px 14px')
        }
      },
      '& .breadcrumb-hover': {
        transition: 'transform .2s ease-in-out 0s',
        '& ~ .normal-breadcrumb-wrap': {
          transition: 'transform .2s ease-in-out 0s'
        },
        '& .sep': {
          '& i': {
            transition: 'transform .15s ease-in-out 0s'
          }
        },
        '&:hover': {
          flex: '1 0 auto',
          // transform: 'translateY(-2px)',
          '& .sep': {
            '& i': {
              transform: 'translateX(8px)'
            }
          }
        }
      },
      //Last Breadcrumb
      '& .last-child': {
        flex: '1 0 auto !important',
        '&:hover': {
          // transform: 'translateY(0)',
          flex: '1 0 auto !important',
          '&:after': {
            display: 'none'
          }
        }
      },
      '& .name-breadcrumbitem': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'initial',
        '& a': {
          display: 'initial'
        }
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  breadcrumbnav: {
    overflow: 'auto',
    '& .name-crumbnav': {
      overflow: 'auto',
      '& .normal-breadcrumb-wrap': {
        display: 'none'
      },
      '& .horizontal-breadcrumb-wrap': {
        display: 'flex'
      }
    }
  }
});

exports.default = _default;